import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-list-check-email',
  templateUrl: './wait-list-check-email.component.html',
  styleUrls: ['./wait-list-check-email.component.scss']
})
export class WaitListCheckEmailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/app/login-module/wait-list-check-email/wait-list-check-email.component.ts